<template>
    <div v-if="tenant && user" class="tables-layout">

        <!-- Tables App Bar -->
        <tables-app-bar />

        <!-- Tables Main Content -->
        <v-main class="no-transition">
            <router-transition>
                <router-view />
            </router-transition>
        </v-main>

        <!-- Tables Footer -->
        <tables-footer />

    </div>
</template>

<script>
import RouterTransition from '@/router/RouterTransition';
import TablesAppBar from '@/views/aria/tables/TablesAppBar';
import TablesFooter from '@/views/aria/tables/TablesFooter';

export default {
    name: 'TablesLayout',

    components: {
        RouterTransition,
        TablesAppBar,
        TablesFooter,
    },

    data() {
        return {
        };
    },
};
</script>

<style scoped lang="scss">
.tables-layout {
    height: 100%;

    -webkit-user-select: none;
    -webkit-app-region: drag;

    .v-main {
        height: 100%;
    }
}
</style>
